<template>
  <div>
    <el-form-item :label='`${type} (sin guiones)`'>
      <el-row :gutter="100">
        <el-col :span='21'>
          <el-input
            v-model='id.model'
            :disabled='isDisabled || disabled'
            maxlength='11'
            show-word-limit
            :class="{'input-warning': id.model.length === 0}"
            @input="saveDataToLocalStorage(id.model,'id')"
          ></el-input>
        </el-col>
        <el-alert v-if="id.model.length === 0" :title="`Ruc Invalido`" type="error" class="message-warning-id" :closable="false"/>
      </el-row>
      <el-row>
        <el-col :span='24'>
          <el-button v-if="!disabled"
            id='verificarID'
            size='small'
            :disabled="idLength !== 11"
            :type='buttonType'
            v-on:click='buttonClickHandler'
            class="button-id"
          >
            {{ buttonText }}
          </el-button>
        </el-col>
      </el-row>
    </el-form-item>
  </div>
</template>

<script>
import { persistToNewProviderStorage, saveDataToLocalStorage } from '../helpers/utils.js'
export default {
  data () {
    return {
      validateID: false
    }
  },
  props: {
    type: {
      type: String,
      default: 'ID'
    },
    idStatus: {
      type: String,
      default: 'accept'
    },
    id: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    idLength () {
      return this.id.model.length
    },
    isDisabled () {
      return this.idStatus === 'edit'
    },
    buttonText () {
      return this.idStatus === 'edit'
        ? `Editar ${this.type}`
        : `Verificar ${this.type}`
    },
    buttonType () {
      return this.idStatus === 'edit' ? 'warning' : 'primary'
    }
  },
  methods: {
    buttonClickHandler () {
      this.$emit('validate-id', this.id)
    },
    persistToNewProviderStorage,
    saveDataToLocalStorage
  }
}
</script>
<style>
  .message-warning-id{
    margin: 10px 0 10px 100px;
    width: 400px;
    height: 40px;
  }
  .button-id{
    margin: 10px 0 10px;
  }
</style>



// WEBPACK FOOTER //
// AltaID.vue?de7b4afa